import { Component } from 'react';
import cx from 'classnames';
import {
  AMOUNT_SELECTION_FIELDS,
  Direction,
  calculateSipFutureValue,
  formatRupeeLiteral,
  calculateLumpsumFutureValue,
  MAX_MF_INVEST_IN_LUMPSUM,
  MAX_MF_INVEST_IN_SIP,
} from '../constants';
import Field from '../components/ui/field';
import Button from './ui/button';

import styles from '../styles/homePage/planCardPopup.scss';
import planStyles from '../styles/homePage/plan.scss';
import Sticky from '../components/ui/sticky';
import { scrollToTarget } from '../utils/commonUtils';
import SuggestedFundsModal from './common/suggestedFundModal';
import amcStyles from '../styles/amcs.scss';
import { parse, stringify } from 'query-string';
import { Router } from '../configs/routes';
import SipAmountCalculator from './sipAmountCalculator';
import QrModal from './common/qrModal';

function getSimpleNameForInvestmentMode(direction: string) {
  return direction === Direction.SIP ? 'SIP (Monthly)' : 'LumpSum (One Time)';
}

class AmountSelection extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      sticky: false,
      selectedCalc: props.sipEnabled ? 'monthly' : 'onetime',
      investmentAmount: props.maxAmount || 5000,
      isAmountValid: true,
      enableSipPlus: false,
      showAppLinkForm: false,
      phone: (props.userInfo && props.userInfo.phoneNumber) || '',
      smsSent: false,
      showQrModal: false,
    };
  }

  public componentDidMount(): void {
    if (this.props.sendSelectedAmt) {
      this.props.sendSelectedAmt(this.state.investmentAmount);
    }
  }

  public switchBtn(id: string) {
    if (id === 'sip-plus') {
      this.setState({
        enableSipPlus: true,
        selectedCalc: '',
      });
      return;
    }
    this.setState(
      {
        selectedCalc: id,
        investmentAmount: this.props.maxAmount || 5000,
        enableSipPlus: false,
      },
      () => {
        this.props.sendSelectedAmt(this.state.investmentAmount);
        const queries = parse(location.search);
        queries.amount = this.state.investmentAmount;
        const preferredInvestmentMode =
          this.state.selectedCalc === 'onetime' ? 'LUMPSUM_MF' : 'SIP_MF';
        queries.investmentType = preferredInvestmentMode;
        Router.pushRoute(`${location.pathname}?${stringify(queries)}`, {
          shallow: true,
        });
      }
    );
  }
  // public onBlurAmount = () => {
  //   const { investmentAmount } = this.state;
  //   const { selectedFund } = this.props;
  //   const roundedAmt = roundOffToStep(
  //     investmentAmount,
  //     selectedFund.lumpsumMultipleAmount
  //   );
  //   this.setState({
  //     investmentAmount: roundedAmt,
  //   });
  // };
  public handleAmountChange = (e: any) => {
    const { value } = e.target;
    const { selectedCalc } = this.state;
    const lumpsumSelected = selectedCalc === 'onetime';
    const {
      selectedFund,
      hasUserInvestedInProduct,
      sipEnabled,
      lumpSumEnabled,
    } = this.props;
    const multipleAmount = selectedFund
      ? selectedFund.lumpsumMultipleAmount || 100
      : 100;
    let investmentAmount = parseInt(value.replace('Rs. ', ''), 10) || 0;

    const {
      minSipAmount,
      minSubsequentAmount,
      maxSipAmount,
      maxLumpsumAmount,
    } = selectedFund;
    const minLumpsumAmount =
      hasUserInvestedInProduct && minSubsequentAmount
        ? minSubsequentAmount
        : selectedFund['minAmount'];

    const maxValue = lumpsumSelected
      ? maxLumpsumAmount || MAX_MF_INVEST_IN_LUMPSUM
      : maxSipAmount || MAX_MF_INVEST_IN_SIP;

    if (investmentAmount > maxValue) {
      e.preventDefault();
      investmentAmount = maxValue;
    }

    let minValue = lumpsumSelected ? minLumpsumAmount : minSipAmount;
    minValue = minValue ? minValue : 500;

    if (investmentAmount < minValue) {
      e.preventDefault();
      investmentAmount = minValue;
    }
    const isAmountValid =
      investmentAmount % multipleAmount !== 0 ? false : true;

    this.setState(
      {
        investmentAmount,
        isAmountValid,
      },
      () => {
        this.props.sendSelectedAmt(investmentAmount);
      }
    );

    let preferredInvestmentMode;
    if (sipEnabled && !lumpSumEnabled) {
      preferredInvestmentMode = 'SIP_MF';
    } else if (!sipEnabled && lumpSumEnabled) {
      preferredInvestmentMode = 'LUMPSUM_MF';
    } else {
      preferredInvestmentMode = lumpsumSelected ? 'LUMPSUM_MF' : 'SIP_MF';
    }

    const queries = parse(location.search);
    queries.amount = investmentAmount;
    queries.investmentType = preferredInvestmentMode;
    Router.pushRoute(`${location.pathname}?${stringify(queries)}`, {
      shallow: true,
    });
  };

  public handleChangeSticky = (sticky: boolean) => {
    this.setState({
      sticky,
    });
  };

  public handleInvestClick = (e: any) => {
    const { sticky } = this.state;
    const { investClick } = this.props;
    if (sticky) {
      scrollToTarget('amount-selection-container');
    } else {
      investClick(e);
    }
  };

  public handleAppLink = () => {
    this.setState({
      showAppLinkForm: true,
    });
  };

  // uncomment this code to enable to send sms from SIP+ tab

  // public handlePhoneChange = (e: any) => {
  //   const val = e.target.value;
  //   this.setState({
  //     phone: val,
  //   });
  // };

  // public handlePhoneSubmit = (e: any) => {
  //   e.preventDefault();
  //   const { phone } = this.state;
  //   api.sendBlackSMS(phone, succeed => {
  //     if (succeed) {
  //       this.setState({
  //         smsSent: true,
  //       });
  //       // this.handleTopCtaTrack(e, 'Success', phone);
  //     }
  //   });
  // };

  public handleQrLink = () => {
    this.setState({
      showQrModal: true,
    });
  };

  private dismiss = () => {
    this.setState({
      showQrModal: false,
    });
  };

  private getEstimatedReturnComp = () => {
    const { isNfo, return3yr } = this.props;

    const { selectedCalc, investmentAmount } = this.state;
    if (isNfo) {
      return null;
    }
    const estimatedRtn = return3yr
      ? formatRupeeLiteral(
          selectedCalc === 'onetime'
            ? calculateLumpsumFutureValue(investmentAmount, 3, return3yr)
            : calculateSipFutureValue(investmentAmount, 3, return3yr)
        )
      : null;

    return (
      <div
        className="lil-flex lil-justify-between"
        style={{ marginTop: '-8px' }}
      >
        <div className="lil-w-2/3 lil-text-s-14">
          <b>Estimated value after 3 years</b> <br />
          <p className="lil-text-s-14 lil-font-medium">
            (as per historical returns)
          </p>
        </div>
        <div
          className={`lilw-1/3 lil-font-semibold ${amcStyles['text-green']}`}
        >
          {estimatedRtn ? `${estimatedRtn} ₹` : '--'}
        </div>
      </div>
    );
  };

  public render() {
    const planData = (this.props.planData || [])[0];
    const return5yr = planData ? planData.planSummary.returns.return5yr : null;
    const {
      className,
      investmentType,
      onChange,
      amount,
      minAmount,
      maxAmount,
      disableButton,
      onFocus,
      showOkayButton,
      onAmountChangeBlur,
      isVariant,
      sipGraphId,
      isFund = false,
      isMaxAmountExceed,
      isMonthlyLimitExceed,
      sipEnabled,
      lumpSumEnabled,
      dismissModal,
      fromSingleFundPage,
      selectedFund,
      returns,
      categoryDetails,
      hasUserInvestedInProduct,
      purchaseMode = '',
    } = this.props;
    const isinCode = this.props.isinCode || '';
    const onlySipEnabled = sipEnabled && !lumpSumEnabled;
    const onlyLumpSumEnabled = !sipEnabled && lumpSumEnabled;
    const investmentNotAllowed = !(sipEnabled || lumpSumEnabled);
    const regularPurchaseMode = purchaseMode === 'REGULAR';
    const investmentNotAllowedText = regularPurchaseMode
      ? `Investment in Regular Funds are no longer available. Switch to Direct Plan of the same fund for higher returns.`
      : `The fund house has restricted SIP and Lumpsum (One-Time) investment in this fund right now.`;
    const sipPlusEnabled =
      sipEnabled && selectedFund && selectedFund.monthlyPrimeSipEnabled;
    const {
      sticky,
      selectedCalc,
      investmentAmount,
      isAmountValid,
      enableSipPlus,
      // showAppLinkForm,
      smsSent,
      showQrModal,
      // phone,
    } = this.state;
    const multipleAmount = selectedFund
      ? selectedFund.lumpsumMultipleAmount
      : 100;
    let minAmountSliderValue;
    let maxAmountSliderValue;
    if (fromSingleFundPage) {
      const { minSipAmount, maxSipAmount, maxLumpsumAmount } = selectedFund;
      const minLumpsumAmount =
        hasUserInvestedInProduct && selectedFund.minSubsequentAmount
          ? selectedFund.minSubsequentAmount
          : selectedFund['minAmount'];

      minAmountSliderValue =
        selectedCalc === 'onetime' ? minLumpsumAmount : minSipAmount;
      maxAmountSliderValue =
        selectedCalc === 'onetime'
          ? maxLumpsumAmount || MAX_MF_INVEST_IN_LUMPSUM
          : maxSipAmount || MAX_MF_INVEST_IN_SIP;
    }
    if (fromSingleFundPage) {
      return (
        <div>
          <div className="lil-flex lil-justify-center lil-mt-6">
            {!onlySipEnabled && (
              <div
                id="switchBtnHolder2"
                onClick={() => this.switchBtn('onetime')}
                className={`lil-w-1/2 lil-text-center
               lil-border-b-lg lil-cursor-pointer
               lil-pb-2
               ${
                 selectedCalc === 'onetime'
                   ? `${amcStyles['border-blue-250']} lil-font-semibold`
                   : 'lil-border-grey-250 '
               }`}
              >
                Lumpsum
              </div>
            )}
            {!onlyLumpSumEnabled && (
              <div
                id="switchBtnHolder1"
                onClick={() => this.switchBtn('monthly')}
                className={`lil-w-1/2 lil-text-center
                          lil-border-b-lg lil-cursor-pointer
                          lil-pb-2
                          ${
                            selectedCalc === 'monthly'
                              ? `${amcStyles['border-blue-250']} lil-font-semibold`
                              : 'lil-border-grey-250 '
                          }`}
              >
                SIP
              </div>
            )}
            {sipPlusEnabled && (
              <div
                id="switchBtnHolder3"
                onClick={() => this.switchBtn('sip-plus')}
                className={`lil-w-1/2 lil-text-center
                lil-border-b-lg lil-cursor-pointer
                lil-pb-2
                ${
                  enableSipPlus
                    ? `${amcStyles['border-blue-250']} lil-font-semibold`
                    : 'lil-border-grey-250 '
                }`}
              >
                SIP+{' '}
                <span className="lil-bg-green-350 lil-p-1 lil-text-white lil-text-s-10 lil-rounded-md">
                  NEW
                </span>
              </div>
            )}
          </div>
          {!enableSipPlus ? (
            <div className="lil-pt-6">
              <div className="lil-flex lil-items-center">
                <div className="lil-w-full">
                  <div className="lil-flex lil-justify-between">
                    <div className="lil-font-semibold">Amount</div>
                    <div className="lil-flex lil-text-right">
                      <span>
                        <input
                          value={investmentAmount}
                          name="amountTextNew"
                          id="investmentAmountText"
                          type="text"
                          max={maxAmountSliderValue}
                          min={minAmountSliderValue || 500}
                          style={{ width: '80px' }}
                          className="lil-border-none lil-text-right"
                          onChange={this.handleAmountChange}
                          // onBlur={this.onBlurAmount}
                        />
                        <span className="lil-pl-2">₹</span>
                      </span>
                    </div>
                  </div>
                  <Field
                    value={investmentAmount}
                    name="amount"
                    id="investmentAmount"
                    type="slider"
                    minSliderValue={minAmountSliderValue}
                    maxSliderValue={maxAmountSliderValue}
                    className="lil-w-full"
                    sliderStep="500"
                    onChange={this.handleAmountChange}
                  />
                </div>
              </div>
              {this.getEstimatedReturnComp()}
              <div className="lil-text-center lil-mt-6">
                <button
                  className={cx('lil-btn lil-w-full lil-btn-blue', {
                    ['lil-btn-disabled']:
                      !isAmountValid || investmentNotAllowed,
                  })}
                  onClick={this.handleInvestClick}
                  disabled={!isAmountValid || investmentNotAllowed}
                >
                  Invest Now ₹{investmentAmount.toLocaleString('en-IN')}
                </button>
                {investmentNotAllowed && (
                  <div className="lil-mt-2 lil-leading-none">
                    <small className="lil-text-red">
                      {investmentNotAllowedText}
                    </small>
                  </div>
                )}
                {!investmentNotAllowed && (
                  <div className="lil-mt-2 lil-font-medium">
                    <small>
                      Min investment of ₹
                      {minAmountSliderValue.toLocaleString('en-IN')} required
                    </small>
                  </div>
                )}
                {!isAmountValid ? (
                  <div className="lil-mt-2">
                    <small className="lil-text-red">
                      Amount should be in multiple of ₹{multipleAmount}
                    </small>
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <div className="lil-pt-6">
              <div className="lil-flex lil-items-center lil-bg-yellow-200 lil-p-2 lil-rounded-sm lil-text-yellow-600">
                <div className="lil-text-s-12">
                  SIP+ is available on BLACK app (Rated 4.9)
                </div>
              </div>
              <div className="lil-flex lil-justify-between lil-mt-8">
                <div>
                  <h5 className="lil-text-s-14">With SIP+, you can</h5>
                  <p className="lil-text-s-12">
                    Start monthly investment at any date with hassle-free SIP
                    edit and pause
                  </p>
                </div>
                <div className="lil-flex-shrink-0">
                  <img src="https://assets1.cleartax-cdn.com/clearsave/images/1643272720_icon.gif" />
                </div>
              </div>
              {smsSent && (
                <span className="lil-text-green-350 lil-text-green-350 lil-font-bold">
                  Download Link is Sent
                </span>
              )}
              {/* Uncomment this code to show get app link button */}

              {/* {!showAppLinkForm ? (
                <div className="lil-text-center lil-mt-6">
                  <button
                    className={cx('lil-btn lil-w-full lil-btn-blue')}
                    onClick={this.handleAppLink}
                  >
                    <img
                      src="https://assets1.cleartax-cdn.com/clearsave/images/1643273262_vector.svg"
                      className="lil-mr-2"
                    />{' '}
                    Get app link
                  </button>
                </div>
              ) : (
                <div className="lil-flex lil-input-action-wrapper lil-rounded-xl lil-mt-6 lil-border-sm lil-border-grey-350 lil-py-6 lil-pl-4 lil-pr-1">
                  <input
                    className="lil-input"
                    value={phone}
                    required
                    pattern="^[789]\d{9}$"
                    placeholder="Your Phone number"
                    type="tel"
                    id="phonetop"
                    name="phone"
                    minlength="10"
                    maxlength="10"
                    onChange={this.handlePhoneChange}
                    disabled={smsSent}
                  />
                  <button
                    className="lil-btn lil-btn-blue lil-text-s-14"
                    onClick={this.handlePhoneSubmit}
                    disabled={smsSent}
                  >
                    Send
                  </button>
                </div>
              )} */}
              <div className="lil-flex lil-items-center lil-mt-4">
                <button
                  className="lil-btn lil-w-full lil-text-blue-350"
                  onClick={this.handleQrLink}
                >
                  <img
                    src="https://assets1.cleartax-cdn.com/clearsave/images/1643273611_scanqr.svg"
                    className="lil-mr-2"
                  />
                  Download via QR
                </button>
              </div>
              {showQrModal && <QrModal onDismiss={this.dismiss} />}
            </div>
          )}
        </div>
      );
    }
    return (
      <div className={cx('row', styles['amount-selection'], styles[className])}>
        <div className="large-12 small-12 columns">
          <div
            className={cx(
              styles.details,
              styles[className],
              styles['amount-selection-box'],
              'paper',
              styles.pinchy
            )}
          >
            {AMOUNT_SELECTION_FIELDS.filter(
              (field) =>
                !(field.name === 'date' && investmentType === Direction.LUMPSUM)
            ).map((field, index) => {
              if (!sipEnabled && !lumpSumEnabled) {
                return (
                  <SuggestedFundsModal
                    dismissModal={dismissModal}
                    isinCode={isinCode}
                  />
                );
              } else if (
                field.name === 'investmentType' &&
                (onlySipEnabled || onlyLumpSumEnabled)
              ) {
                return (
                  <div
                    key={`no-array-${index}`}
                    className={cx(
                      styles['investment-mode-container'],
                      'clearfix'
                    )}
                  >
                    Investment mode is{' '}
                    {onlySipEnabled
                      ? getSimpleNameForInvestmentMode('SIP_MF')
                      : getSimpleNameForInvestmentMode('LUMPSUM_MF')}
                  </div>
                );
              } else {
                return (
                  <div key={`${field.name}-${index}`} className="clearfix">
                    <Field
                      id={field.name}
                      {...field}
                      onChange={onChange}
                      className={cx(field.className, styles['radioLabel'])}
                      value={this.props[field.name]}
                      onBlur={
                        field.name === 'amount' ? onAmountChangeBlur : null
                      }
                      onFocus={onFocus || null}
                    />

                    {field.name === 'amount' && showOkayButton ? (
                      <div className="large-2 columns">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            onAmountChangeBlur(e);
                          }}
                          className={cx(
                            styles['edit-funds'],
                            'inline-block desktop-only float--right text--sm',
                            planStyles['edit-funds-link'],
                            styles['okay-button']
                          )}
                        >
                          OKAY
                        </a>
                      </div>
                    ) : null}

                    {field.name === 'amount' ? (
                      <div className="large-12 small-12 columns">
                        <p
                          className={cx(
                            'text--sm font--grey m-nostyle',
                            styles['min-amount']
                          )}
                        >
                          Min amount: ₹
                          {minAmount && minAmount.toLocaleString('en-IN')}{' '}
                          {isFund && maxAmount
                            ? `|  Max amount: ₹${
                                maxAmount && maxAmount.toLocaleString('en-IN')
                              }`
                            : null}
                        </p>
                      </div>
                    ) : null}
                    {field.name === 'amount' && isMaxAmountExceed ? (
                      <div className="large-12 small-12 columns">
                        <p className={cx('text--sm font--red')}>
                          Max investment allowed is ₹
                          {maxAmount.toLocaleString('en-IN')}
                        </p>
                      </div>
                    ) : null}
                    {field.name === 'amount' && isMonthlyLimitExceed ? (
                      <div className="large-12 small-12 columns">
                        <p className={cx('text--sm font--red')}>
                          This fund allows a maximum of ₹
                          {maxAmount.toLocaleString('en-IN')} per month in SIP
                        </p>
                      </div>
                    ) : null}
                  </div>
                );
              }
            })}
            <div className="p10">
              <Sticky
                disableDesktop={true}
                fullWidth={true}
                stickyBottom={true}
                stickyOffset={60}
                changeSticky={this.handleChangeSticky}
                noPadding={true}
              >
                <div>
                  {sticky && isVariant ? (
                    <Button
                      className={cx(
                        's-btn s-btn--white columns small-6 mobile-only-display',
                        styles['request-callback-cta']
                      )}
                      label={'Request Callback'}
                      onClick={() => scrollToTarget('mobile-request-callback')}
                    />
                  ) : null}
                  <Button
                    className={cx(
                      's-btn s-btn--orange btn-caps btn-shine full-width',
                      styles['action-button'],
                      { 'columns small-6': sticky && isVariant }
                    )}
                    disabled={disableButton}
                    loadingLabel="Investing..."
                    onClick={this.handleInvestClick}
                    label="Invest Now"
                  />
                </div>
              </Sticky>
            </div>
            {return5yr && !isVariant ? (
              <SipAmountCalculator
                {...this.props}
                investmentType={investmentType}
                amount={amount}
                return5yr={return5yr}
                showResult
                sipGraphId={sipGraphId}
                returns={returns}
                categoryDetails={categoryDetails}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default AmountSelection;



// WEBPACK FOOTER //
// ./components/amountSelection.tsx